export default "__VITE_ASSET__DSpbf9PB__"